var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46639 11.2382C7.54453 11.162 7.60652 11.0716 7.64882 10.972C7.69112 10.8724 7.71289 10.7656 7.71289 10.6578C7.71289 10.55 7.69112 10.4432 7.64882 10.3436C7.60652 10.244 7.54453 10.1535 7.46639 10.0774L3.02448 5.73921L7.46639 1.40103C7.62394 1.2471 7.71245 1.03833 7.71245 0.820643C7.71245 0.602955 7.62394 0.394181 7.46639 0.240252C7.30884 0.0863218 7.09516 -0.000153573 6.87235 -0.000153584C6.64954 -0.000153595 6.43585 0.0863218 6.2783 0.240251L1.24403 5.15882C1.16589 5.23497 1.1039 5.32543 1.0616 5.42502C1.0193 5.52462 0.997529 5.63138 0.997529 5.73921C0.997529 5.84704 1.0193 5.9538 1.0616 6.0534C1.1039 6.15299 1.16589 6.24345 1.24403 6.3196L6.2783 11.2382C6.35624 11.3145 6.44883 11.3751 6.55077 11.4164C6.6527 11.4577 6.76198 11.479 6.87235 11.479C6.98271 11.479 7.09199 11.4577 7.19392 11.4164C7.29586 11.3751 7.38845 11.3145 7.46639 11.2382Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7461 5.7403C12.7461 5.52289 12.6577 5.31438 12.5003 5.16065C12.343 5.00691 12.1296 4.92055 11.907 4.92055L3.51657 4.92055C3.29404 4.92055 3.08062 5.00691 2.92327 5.16065C2.76592 5.31438 2.67752 5.52289 2.67752 5.7403C2.67752 5.95771 2.76592 6.16622 2.92327 6.31996C3.08062 6.47369 3.29404 6.56006 3.51657 6.56006L11.907 6.56006C12.1296 6.56006 12.343 6.47369 12.5003 6.31996C12.6577 6.16622 12.7461 5.95772 12.7461 5.7403Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9688 5.7403C17.9688 5.52289 17.8804 5.31438 17.723 5.16065C17.5656 5.00691 17.3522 4.92055 17.1297 4.92055L8.73923 4.92055C8.5167 4.92055 8.30328 5.00691 8.14593 5.16065C7.98858 5.31438 7.90018 5.52289 7.90018 5.7403C7.90018 5.95771 7.98858 6.16622 8.14593 6.31996C8.30328 6.47369 8.5167 6.56006 8.73923 6.56006L17.1297 6.56006C17.3522 6.56006 17.5656 6.47369 17.723 6.31996C17.8804 6.16622 17.9688 5.95772 17.9688 5.7403Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.797febf003e26b3fce6725014582620e.svg";
export { ForwardRef as ReactComponent };